import React, {Component} from "react";
import {Tabs} from 'antd';
import getSize from "../../../utils/getSize";
import QxjfcxtjTab from "./qxjfcxtjTab";
import XyjfcxtjTab from "./xyjfcxtjTab";
import css from './index.css';

const TabPane = Tabs.TabPane;

/**
 * 学生缴费查询统计
 * @author huangjiabiao
 * @date 2019-09-05 13:49:22
 * Version: 1.0
 */
export default class Xsjfcxtj extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            defaultActiveKey: undefined,
        }
    }


    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 130}}>
                <Tabs defaultActiveKey={this.state.defaultActiveKey}>
                    <TabPane tab="学院缴费统计" key="1"><XyjfcxtjTab/></TabPane>
                    <TabPane tab="全校缴费统计" key="2"><QxjfcxtjTab/></TabPane>
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/xsjfcxtj/index.js